import axios from "axios";
import axiosRetry from "axios-retry";
import { InMemoryStorage, IndexedDBStorage } from "./fileStorage";
axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });


export const formatInputNumber = (value) => {
    return value.toString().replace('.', ',');
}

export const formatDecimal = (number, maximumFractionDigits = 2, decimalSeparator = ',', locale = 'fr-FR') => {
    number = parseFloat(number);
    return number.toLocaleString(
        locale,
        {
            minimumFractionDigits: 1, 
            maximumFractionDigits: maximumFractionDigits, 
            decimalSeparator
        }
    );
}

export const customAxios = () => {
    const baseURL = process.env.REACT_APP_API_URL || 'http://api.cf-demo.com/api/v1';
    const axiosInstance = axios.create({
        baseURL: baseURL,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        credentials: 'include'
    });
    axiosInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;
            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    await axiosInstance.get('/token/refresh');
                    originalRequest.withCredentials = true;
                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    return Promise.reject(error);
                }
            }
            return Promise.reject(error);
        }
    );
    return axiosInstance;
}

export let fileStorage = null;

// Initialize the fileStorage
const getFileStorage = async () => {
    const fileStorage = typeof window !== 'undefined' ? new IndexedDBStorage() : new InMemoryStorage();
    if (!fileStorage.isInit) {
        await fileStorage.init();
    }
    return fileStorage;
};

getFileStorage().then(storage => {
    fileStorage = storage;
});

export const modelPollingPromise = (model, data = null) => new Promise((resolve, reject) => {
    (
        data === null ? 
        customAxios().post(`/model/${model}/init`) : 
        customAxios().post(`/model/${model}/init`, data)
    )
        .then(response => {
            if (!response.data || !response.data.id) {
                return reject(new Error('Failed to poll data'));
            }
            
            const id = response.data.id;
            let attempts = 0;
            const maxAttempts = 50;
            const pollingInterval = 5000;
            
            const pollProcessStatus = () => {
                attempts++;
                customAxios().post(`/model/${model}/get`, { id })
                    .then(response => {
                        if (response.data.status === "finished") {
                            resolve(response);
                        } else if (response.data.status === "pending" && attempts < maxAttempts) {
                            setTimeout(pollProcessStatus, pollingInterval);
                        } else {
                            reject(new Error('Process timed out'));
                        }
                    })
                    .catch(error => {
                        reject(new Error('Failed to poll data'));
                    });
            };
            
            pollProcessStatus();
        })
        .catch(error => {
            reject(new Error('Failed to initiate process'));
        });
});